import { Component, Input, OnInit } from '@angular/core';
import { ApiEmailService } from '../../../___LOGIC/__api/api-email.service';
import { GuiFlowService } from '../../../___LOGIC/__gui/gui-flow.service';

@Component({
  selector: 'app-email-preview',
  templateUrl: './email-preview.component.html',
  styleUrls: ['./email-preview.component.css']
})
export class EmailPreviewComponent implements OnInit {

  @Input() emailFormData;
  @Input() config;

  constructor(private emailService: ApiEmailService, private guiFLow: GuiFlowService) {}

  ngOnInit(): void {

  }

  isLoading(){
    return this.emailService.isPreviewLoading();
  }

}